import { Controller } from '@hotwired/stimulus'

export default class DropdownController extends Controller {
  static targets = ['menu', 'button'];

  connect() {
    this.menu = this.menuTarget;
    this.button = this.buttonTarget;
    document.body.appendChild(this.menu);
  }

  disconnect() {
    if (this.menu && this.menu.parentNode === document.body) {
      this.menu.remove();
    }
  }

  toggle() {
    if (this.menu.classList.contains('show')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.closeAll(this.menu);

    this.menu.style.display = 'block';
    this.menu.style.visibility = 'hidden';

    this.positionMenu();

    this.menu.style.visibility = 'visible';
    this.menu.classList.add('show');
    this.button.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.menu.classList.remove('show');
    this.menu.style.display = 'none';
    this.button.setAttribute('aria-expanded', 'false');
  }

  closeOnClickOutside(event) {
    if (!this.menu.classList.contains('show')) return;

    if (!this.element.contains(event.target) && !this.menu.contains(event.target)) {
      this.close();
    }
  }

  positionMenu() {
    const menu = this.menu;
    const button = this.button;
    const rect = button.getBoundingClientRect();

    const menuWidth = menu.offsetWidth;
    const menuHeight = menu.offsetHeight;
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const scrollY = window.scrollY;
    const scrollX = window.scrollX;

    let top = rect.bottom + scrollY;
    let left = rect.right + scrollX - menuWidth;

    if (left < scrollX + 10) {
      left = rect.left + scrollX;
    }

    if (left + menuWidth > scrollX + vw - 10) {
      left = scrollX + vw - menuWidth - 10;
    }

    if (top + menuHeight > scrollY + vh - 10) {
      top = rect.top + scrollY - menuHeight;
      if (top < scrollY + 10) {
        top = rect.bottom + scrollY;
      }
    }

    menu.style.position = 'absolute';
    menu.style.top = `${top}px`;
    menu.style.left = `${left}px`;
    menu.style.zIndex = '1050';
    menu.style.maxHeight = `${vh - 20}px`;
    menu.style.overflowY = 'auto';
  }

  updatePosition() {
    if (this.menu.classList.contains('show')) {
      this.positionMenu();
    }
  }

  // close opened dropdown before open a new one
  closeAll() {
    document.querySelectorAll('.dropdown-menu.show').forEach(menu => {
      menu.classList.remove('show');
      menu.style.display = 'none';

      const controllerElement = document.querySelector('[data-controller="dropdown"]');
      const button = controllerElement?.querySelector('[data-dropdown-target="button"]');

      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  }
}
